import React, { useState, useRef, useEffect, useMemo } from "react";
import { addResearchData, deleteResearchData, editResearchData, getResearchData } from "../../controllers/sabsrc.controller"
import toast from 'react-hot-toast';
import {
    IconPlus,
} from "@tabler/icons-react";
import { RiListRadio, RiDeleteBin2Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import Button from "../../Components/Button";
import Page from "../../Components/Page";

const SABSRC = () => {
    const [year, setYear] = useState('');
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [researcherName, setResearcherName] = useState('');
    const [isModalOpenAdd, setisModalOpenAdd] = useState(false);
    const [modalData, setModalData] = useState({ index: null, value: "" });
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [isOpen, setIsOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [data, setData] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);

    const years = Array.from({ length: 201 }, (_, i) => 1900 + i); // 1900 to 2100

    const handleYearClick = (year) => {
        setSelectedYear(year);
        setIsOpen(false);
    };
    const [formData, setFormData] = useState({
        year: new Date().getFullYear(),
        title: "",
        description: "",
        files: null,
        researcherName: "",
        qrCode: "",  // Add qrCode to state
        image: null,   // Add image to state
        filePath: "",  // Add filePath to state to store the URL of the existing file
        imagePath: "", // Add imagePath to state to store the URL of the existing image
    });

    // setFormData((prevState) => ({
    //     ...prevState,
    //     file: { file: { name: '' } }
    // }))



    const [toggles, setToggles] = useState([
        { label: 'Add New', icon: <IconPlus />, isToggled: false },
        { label: 'List', icon: <RiListRadio />, isToggled: true },
    ]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        setFormData({ ...formData, files: e.target.files[0], filePath: e.target.files[0]?.name });
    };

    const handleImageChange = (e) => {
        setFormData({ ...formData, image: e.target.files[0], imagePath: e.target.files[0]?.name });
    };





    const fetchTableData = async () => {
        const res = await getResearchData({})
        console.log('res => ', res)

        if (res.status === 200) {
            const apiData = res?.data?.data;
            const tableData = apiData?.map((d) => ({
                id: d.id,
                title: d.title,
                description: d.description,
                researcherName: d.researcherName,
                year: d.year,
                qrCode: d.qrCode || "", // Add qrCode to table data
                image: d.image_url || "", // Add image to table data
                filePath: d.files && d.files.length > 0 ? d.files[0] : "",
                imagePath: d.image && d.image.length > 0 ? d.image[0] : "",
            }))
            setData(tableData)
        }
    }

    useEffect(() => {
        fetchTableData()
    }, [])

    const addNewReseach = async () => {
        try {
            const { year, title, description, files, researcherName, qrCode, image } = formData;

            if (!year || !title || !description || !researcherName) {
                toast.error("Please fill in all the required fields and upload a document and an image.");
                return;
            }

            toast.loading("Submitting your data...");

            const formDataToSend = new FormData();
            formDataToSend.append("year", year);
            formDataToSend.append("title", title);
            formDataToSend.append("description", description);
            formDataToSend.append("files", files);
            formDataToSend.append("researcherName", researcherName);
            formDataToSend.append("qrCode", qrCode);
            formDataToSend.append("image", image);

            const res = await addResearchData(formDataToSend);

            const message = res.data.message;
            toast.dismiss();

            if (res.status === 200) {
                toast.success(message);
                setFormData({
                    year: "",
                    title: "",
                    description: "",
                    files: null,
                    researcherName: "",
                    qrCode: "",
                    image: null,
                    filePath: "",
                    imagePath: ""
                });
                setSelectedYear(new Date().getFullYear());
                fetchTableData()
            } else {
                toast.error(message || "Failed to add research data.");
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error adding research data:", error);

            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
        }
    };

    const editReseachBtn = async () => {
        try {
            const { year, title, description, files, researcherName, qrCode, image } = formData;

            if (!year || !title || !description || !researcherName || !qrCode ) {
                toast.error("Please fill in all the required fields.");
                return;
            }

            toast.loading("Submitting your data...");
            const formDataToSend = new FormData();
            // formDataToSend.append("id", selectedRowId);
            formDataToSend.append("year", year);
            formDataToSend.append("title", title);
            formDataToSend.append("description", description);

            if (files) {
               formDataToSend.append("files", files);
            }

            formDataToSend.append("researcherName", researcherName);
            formDataToSend.append("qrCode", qrCode);
             if (image) {
                formDataToSend.append("image", image);
            }
            console.log("id",selectedRowId)

            const res = await editResearchData(selectedRowId,formDataToSend);

            const message = res.data.message;
            toast.dismiss();

            if (res.status === 200) {
                toast.success(message);
                setFormData({
                    year: "",
                    title: "",
                    description: "",
                    files: null,
                    researcherName: "",
                    qrCode: "",
                    image: null,
                    filePath: "",
                    imagePath: ""
                });
                setSelectedYear(new Date().getFullYear());
                document.getElementById("modal-edit").close()
                fetchTableData()
            } else {
                toast.error(message || "Failed to add research data.");
            }
        } catch (error) {
            toast.dismiss();
            console.error("Error adding research data:", error);

            const message = error?.response?.data?.message || "Something went wrong!";
            toast.error(message);
        }
    };

    const deleteResearchBtn = async () => {
        try {
            if (selectedRowId) {
                toast.loading("Please wait...");
                const res = await deleteResearchData({ id: selectedRowId })
                const message = res.data.message;
                toast.dismiss();
                if (res.status === 200) {
                    toast.success(message);
                    fetchTableData()
                    setSelectedRowId(null)
                    document.getElementById("modal-delete").close()
                } else {
                    toast.error(message);
                }
            }
        } catch (error) {
            console.error(error);
            const message = error?.response?.data?.error || "Something went wrong!";
            toast.dismiss();
            toast.error(message);
        }
    }

    const handleToggle = (index) => {
        setToggles((prevToggles) =>
            prevToggles.map((toggle, i) => ({ ...toggle, isToggled: i === index }))
        );
    };

    const toggeledIndex = useMemo(() => {
        return toggles.findIndex((d) => d.isToggled)
    }, [toggles])

    return (
        <Page className="px-8 py-6">
            <div className='flex items-center gap-10 text-xl'>
                <div className="text-[#100f13]">
                    Research & Student Life / Research /  <span className="text-[black] bg-white mt-6">  SAB SRC</span>
                </div>
            </div>
            <div className="flex flex-wrap gap-4 mt-4">
                {toggles.map((toggle, index) => (
                    <div key={toggle.id} className="flex flex-col items-center">

                        <Button styles={'h-100'} outlined={!toggle.isToggled} onClick={() => handleToggle(index)}>
                            <span className="flex flex-row items-center justify-center w-[150px]">{toggle.icon} {toggle.label}</span>
                        </Button>

                    </div>

                ))}
            </div>

            <div className="w-full p-6 mx-auto mt-10 bg-white rounded-lg shadow-lg">
                {toggeledIndex === 1 ? (
                    <div>
                        <h1 className="text-xl font-bold mb-2 text-[#4B465C] mt-6">Department List</h1>
                        <p className="mb-4 text-gray-600">A total of 5 images you can collect!</p>

                        <table className="w-full bg-white border-collapse rounded-lg shadow-md">
                            <thead>
                                <tr className="bg-gray-100 text-[#4B465C]">
                                    <th className="w-1/4 px-4 py-2 text-center">Title</th>
                                    <th className="w-1/4 px-4 py-2 text-center">Researcher Name</th>
                                    <th className="w-1/4 px-4 py-2 text-center">Year</th>
                                    <th className="w-1/4 px-4 py-2 text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <tr key={item.id} className="border-b hover:bg-gray-50">
                                        <td className="px-4 py-2 text-center">{item.title}</td>
                                        <td className="px-4 py-2 text-center">{item.researcherName}</td>
                                        <td className="px-4 py-2 text-center">{item.year}</td>
                                        <td className="px-4 py-2 text-center">
                                            <div className="flex justify-center gap-4">
                                                <button
                                                    onClick={() => {
                                                        setSelectedRowId(item.id)
                                                        document.getElementById("modal-delete").showModal();
                                                    }}
                                                    className="flex items-center px-3 py-1 bg-[#A8AAAE14] text-[#A8AAAE] border border-[#A8AAAE] rounded-md hover:bg-gray-300"
                                                >
                                                    Delete
                                                    <RiDeleteBin2Line className="ml-2" />
                                                </button>
                                                <button onClick={() => {
                                                    setSelectedRowId(item.id)
                                                    setFormData((prevState) => ({
                                                        ...prevState,
                                                        year: item.year,
                                                        title: item.title,
                                                        description: item.description,
                                                        researcherName: item.researcherName,
                                                        qrCode: item.qrCode || "",
                                                        files: null,  // Important to reset files
                                                        image: null,  // Important to reset image
                                                        filePath: item.filePath || "",  // Set existing file path
                                                        imagePath: item.imagePath || ""  // Set existing image path
                                                    }));
                                                    document.getElementById("modal-edit").showModal();
                                                }} className="px-3 py-1 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md flex items-center gap-1">
                                                    Edit
                                                    <FiEdit />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div>
                        <h1 className="mb-6 text-2xl font-bold">Add Research</h1>
                        <form onSubmit={(e) => e.preventDefault()}>
                            <div className="flex items-start gap-6">
                                {/* Year Picker */}
                                <div className="relative flex-1">
                                    <label className="block mb-2 text-gray-600" htmlFor="year-picker">
                                        Year
                                    </label>
                                    <div
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg cursor-pointer focus:ring-2 focus:ring-blue-500"
                                        id="year-picker"
                                        onClick={() => setIsOpen(!isOpen)}
                                    >
                                        {selectedYear || "Select Year"}
                                    </div>

                                    {isOpen && (
                                        <div className="absolute z-10 mt-2 overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg max-h-56">
                                            <div className="grid grid-cols-4 gap-2 p-4">
                                                {years.map((year) => (
                                                    <button
                                                        key={year}
                                                        onClick={() => {
                                                            handleYearClick(year);
                                                            setFormData({ ...formData, year });
                                                        }}
                                                        className={`px-4 py-2 rounded-lg text-center ${year === selectedYear
                                                            ? "bg-blue-500 text-white"
                                                            : "hover:bg-gray-100"
                                                            }`}
                                                    >
                                                        {year}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Title Input */}
                                <div className="flex-1">
                                    <label htmlFor="title" className="block mb-2 text-gray-600">
                                        Title
                                    </label>
                                    <input
                                        type="text"
                                        id="title"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}

                                        className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                    />
                                </div>
                            </div>

                            <div className="mb-4">
                                <label htmlFor="description" className="block text-sm font-medium text-gray-700">
                                    Description
                                </label>
                                <textarea
                                    id="description"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    rows="4"

                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="file" className="block text-sm font-medium text-gray-700">
                                    Upload Documents
                                </label>
                                <div className="flex items-center gap-4 mt-1">
                                    <input
                                        type="text"
                                        value={formData.files ? formData.files.name : ""}
                                        readOnly
                                        placeholder="No file selected"
                                        className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                    />
                                    <label
                                        htmlFor="file"
                                        className="px-3 py-2 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md cursor-pointer"
                                    >
                                        Browse File
                                    </label>
                                    <input
                                        type="file"
                                        id="file"
                                        name="file"
                                        onChange={handleFileChange}
                                        className="hidden"
                                    />
                                    {formData.files && (
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setFormData({ ...formData, files: null });
                                            }}
                                            className="px-3 py-2 text-white bg-red-500 rounded-md hover:bg-red-600"
                                        >
                                            Remove
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="mb-4">
                                <label htmlFor="researcherName" className="block text-sm font-medium text-gray-700">
                                    Researcher Name
                                </label>
                                <input
                                    type="text"
                                    id="researcherName"
                                    name="researcherName"
                                    value={formData.researcherName}
                                    onChange={handleChange}

                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="qrCode" className="block text-sm font-medium text-gray-700">
                                    QR Code
                                </label>
                                <input
                                    type="text"
                                    id="qrCode"
                                    name="qrCode"
                                    value={formData.qrCode}
                                    onChange={handleChange}
                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                />
                            </div>

                            <div className="mb-4">
                                <label htmlFor="image" className="block text-sm font-medium text-gray-700">
                                    Image
                                </label>
                                <div className="flex items-center gap-4 mt-1">
                                    <input
                                        type="text"
                                        accept="image/*"
                                        value={formData.image ? formData.image.name : ""}
                                        readOnly
                                        placeholder="No image selected"
                                        className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                    />
                                    <label
                                        htmlFor="image"
                                        className="px-3 py-2 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md cursor-pointer"
                                    >
                                        Browse Image
                                    </label>
                                    <input
                                        type="file"
                                        id="image"
                                        accept=".png, .jpg, .jpeg, .webp"

                                        name="image"
                                        onChange={handleImageChange}
                                        className="hidden"
                                    />
                                    {formData.image && (
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setFormData({ ...formData, image: null });
                                            }}
                                            className="px-3 py-2 text-white bg-red-500 rounded-md hover:bg-red-600"
                                        >
                                            Remove
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="flex justify-end space-x-4">
                                <button
                                    type="button"
                                    className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md"
                                    onClick={() => {
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    onClick={addNewReseach}
                                    className="px-4 py-2 bg-[#92288C] text-white rounded-md"
                                >
                                    Save
                                </button>


                            </div>
                        </form>
                    </div>
                )
                }
            </div>
            <dialog
                id="modal-edit"
                className="modal modal-bottom xl:modal-middle inset-0 z-50 rounded-lg w-[600px]"
            >
                <div className="p-6">
                    <h1 className="mb-6 text-2xl font-bold">Edit Research</h1>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <div className="flex items-start gap-6">
                            {/* Year Picker */}
                            <div className="relative flex-1">
                                <label className="block mb-2 text-gray-600" htmlFor="year-picker">
                                    Year
                                </label>
                                <div
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg cursor-pointer focus:ring-2 focus:ring-blue-500"
                                    id="year-picker"
                                    onClick={() => setIsOpen(!isOpen)}
                                >
                                    {formData.year || "Select Year"}
                                </div>

                                {isOpen && (
                                    <div className="absolute z-10 mt-2 overflow-y-auto bg-white border border-gray-300 rounded-lg shadow-lg max-h-56">
                                        <div className="grid grid-cols-4 gap-2 p-4">
                                            {years.map((year) => (
                                                <button
                                                    key={year}
                                                    onClick={() => {
                                                        handleYearClick(year);
                                                        setFormData({ ...formData, year });
                                                    }}
                                                    className={`px-4 py-2 rounded-lg text-center ${year === formData.year
                                                        ? "bg-blue-500 text-white"
                                                        : "hover:bg-gray-100"
                                                        }`}
                                                >
                                                    {year}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Title Input */}
                            <div className="flex-1">
                                <label htmlFor="title" className="block mb-2 text-gray-600">
                                    Title
                                </label>
                                <input
                                    type="text"
                                    id="title"
                                    name="title"
                                    value={formData.title}
                                    onChange={handleChange}
                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                />
                            </div>
                        </div>

                        <div className="mb-4">
                            <label htmlFor="description" className="block text-sm font-medium text-gray-700">
                                Description
                            </label>
                            <textarea
                                id="description"
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                rows="4"
                                className="block w-full mt-1 border-gray-300 rounded-md shadow-sm"
                            />
                        </div>

                        <div className="mb-4">
                            <label htmlFor="file" className="block text-sm font-medium text-gray-700">
                                Upload Documents
                            </label>
                            <div className="flex items-center gap-4 mt-1">
                                <input
                                    type="text"
                                    value={formData.filePath || (formData.files ? formData.files.name : "")}
                                    readOnly
                                    placeholder="No file selected"
                                    className="flex-grow px-3 py-2 text-gray-500 border-gray-300 rounded-md shadow-sm"
                                />
                                <label
                                    htmlFor="file"
                                    className="px-3 py-2 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md cursor-pointer"
                                >
                                    Browse File
                                </label>
                                <input
                                    type="file"
                                    id="file"
                                    name="file"
                                    onChange={handleFileChange}
                                    className="hidden"
                                />
                                {formData.files && (
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setFormData({ ...formData, files: null, filePath: "" });
                                        }}
                                        className="px-3 py-2 text-white bg-red-500 rounded-md hover:bg-red-600"
                                    >
                                        Remove
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="mb-4">
                            <label htmlFor="researcherName" className="block text-sm font-medium text-gray-700">
                                Researcher Name
                            </label>
                            <input
                                type="text"
                                id="researcherName"
                                name="researcherName"
                                value={formData.researcherName}
                                onChange={handleChange}
                                className="block w-full mt-1 border-gray-300 rounded-md shadow-sm"
                            />
                        </div>

                        <div className="mb-4">
                            <label htmlFor="qrCode" className="block text-sm font-medium text-gray-700">
                                QR Code
                            </label>
                            <input
                                type="text"
                                id="qrCode"
                                name="qrCode"
                                value={formData.qrCode}
                                onChange={handleChange}
                                className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                            />
                        </div>

                        <div className="mb-4">
                            <label htmlFor="image" className="block text-sm font-medium text-gray-700">
                                Image
                            </label>
                            <div className="flex items-center gap-4 mt-1">
                                <input
                                    type="text"
                                    accept=".png, .jpg, .jpeg, .webp"
                                    value={formData.imagePath || (formData.image ? formData.image.name : "")}
                                    readOnly
                                    placeholder="No image selected"
                                    className="block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm"
                                />
                                <label
                                    htmlFor="image"
                                    className="px-3 py-2 bg-[#92288C14] text-[#92288C] border border-[#92288C] rounded-md cursor-pointer"
                                >
                                    Browse Image
                                </label>
                                <input
                                    type="file"
                                    accept=".png, .jpg, .jpeg, .webp"
                                    id="image"
                                    name="image"
                                    onChange={handleImageChange}
                                    className="hidden"
                                />
                                {formData.image && (
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setFormData({ ...formData, image: null, imagePath: "" });
                                        }}
                                        className="px-3 py-2 text-white bg-red-500 rounded-md hover:bg-red-600"
                                    >
                                        Remove
                                    </button>
                                )}
                            </div>
                        </div>

                        <div className="flex justify-end space-x-4">
                            <button
                                type="button"
                                className="px-4 py-2 text-gray-700 bg-gray-200 rounded-md"
                                onClick={() => {
                                    document.getElementById("modal-edit").close()
                                    setSelectedRowId(null)
                                    setFormData((prevState) => ({
                                        ...prevState,
                                        year: '',
                                        title: '',
                                        description: '',
                                        researcherName: '',
                                        qrCode: '',
                                        image: '',
                                        files: null,
                                        filePath: "",
                                        imagePath: ""
                                    }))
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={editReseachBtn}
                                className="px-4 py-2 bg-[#92288C] text-white rounded-md"
                            >
                                Save
                            </button>
                        </div>
                    </form>
                </div>
            </dialog>

            <dialog
                id="modal-delete"
                className="inset-0 z-50 rounded-lg modal modal-bottom sm:modal-middle"
            >

                <div className="relative z-10 w-full max-w-lg p-6 mx-auto bg-white rounded-lg shadow-lg">
                    <div className="text-center">
                        <h2 className="text-xl font-bold text-gray-900">
                            Delete
                        </h2>
                        <p className="font-bold text-gray-500">
                            Are you sure?
                        </p>
                    </div>


                    <div className="flex justify-center mt-4 space-x-4">
                        <button
                            onClick={() => {
                                setSelectedRowId(null)
                                document.getElementById("modal-delete").close()
                            }}
                            className="px-6 py-3 text-gray-600 transition bg-gray-200 rounded-lg hover:bg-gray-200 active:scale-95 hover:shadow-lg"
                        >
                            No
                        </button>
                        <button
                            onClick={async () => {
                                deleteResearchBtn();
                            }}
                            className="rounded-lg transition active:scale-95 hover:shadow-lg px-6 py-3 bg-[#92288C] text-white"
                        >
                            Yes
                        </button>
                    </div>
                </div>
            </dialog>

        </Page>

    );
};

export default SABSRC;